import { useRef } from "react"
import emailjs from "@emailjs/browser";
import { useForm } from "react-hook-form";
import { commonInfo, formQuestions } from "./Data";

export default function Form() {
  const form = useRef();
  const sendToEmail = (e) => {
     emailjs.sendForm(process.env.REACT_APP_EMAILJS_GMAIL_SERVICE_ID, process.env.REACT_APP_EMAILJS_EMAIL_TEMPLATE_ID, form.current, process.env.REACT_APP_EMAILJS_PUBLIC_KEY).then(
        (result) => {
           alert("感謝您的查詢，我們會有專人儘快與您聯絡。");
        },
           (error) => {
           alert(`抱歉！未能提交查詢，請聯絡${commonInfo.phone}跟進。`);
        }
     );
  };

  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const onSubmit = data => {
     sendToEmail()
     reset()
  };

  const errorMessage = //for textarea input
  {
     required: '請填寫此欄',
     max200: '字數上限為200字',
  }

  const errorStyle = (condition) => {
     if (condition) {
      return {
         backgroundColor: '#fbecf2',
         border: '1px solid #ec5990',
         borderWidth: '1px 1px 1px 10px',
         transition: 'all .3s'

      }
     }

  };

  return (
<div className="w-full lg:w-1/2 xl:w-5/12 px-4">
            <div className="bg-white relative rounded-lg p-4 sm:p-12 shadow-lg">
               <form onSubmit={handleSubmit(onSubmit)} ref={form} noValidate>
                  {formQuestions.map((question) => (
                     <div key={question.name} className="mb-6">
                     <question.htmlTag
                        row = {question.rows}
                        type = {question.type}
                        placeholder= {question.placeholder}
                        className="w-full rounded py-3 px-4 text-body-color text-base border border-[f0f0f0] outline-none focus-visible:shadow-none focus:border-primary "
                        style={errorStyle(errors[question.name])}
                        name={question.name}
                        {...register(question.name, question.validations)}
                        />
                        {Object.keys(question.validations).map((validation, index) => (
                           errors[question.name]?.type === validation && <span key={index} className="block mt-2 text-red-600 text-xs">{question.errorMessages[validation]}</span>
                        ))}
                     </div>
                     ))}
                  <div>
                     <button
                        type="submit"
                        className="
                        w-full
                        text-white
                        bg-[#3056d3]
                        rounded
                        border border-primary
                        p-3
                        transition
                        hover:bg-opacity-90
                        "
                        >
                     確認提交
                     </button>
                  </div>
               </form>
               <div>
                  <span className="absolute -top-10 -right-7 z-[-1]">
                     <svg
                        width="100"
                        height="100"
                        viewBox="0 0 100 100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                           fillRule="evenodd"
                           clipRule="evenodd"
                           d="M0 100C0 44.7715 0 0 0 0C55.2285 0 100 44.7715 100 100C100 100 100 100 0 100Z"
                           fill="#3056D3"
                           />
                     </svg>
                  </span>

               </div>
            </div>
         </div>
  )
}
